import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function TaskProgress({ stats }) {
  const total = stats.total_tasks ?? 0;
  const completed = stats.completed_tasks ?? 0;
  const percent = total ? Math.round((completed / total) * 100) : 0;
  const segments = [
    ["Completed", completed, "completed"],
    ["In progress", stats.in_progress_tasks ?? 0, "progress"],
    ["Assigned", stats.assigned_tasks ?? 0, "assigned"],
  ];
  return (
    <section
      className="dashboard-panel delivery-panel"
      aria-labelledby="delivery-title"
    >
      <div className="panel-heading">
        <div>
          <h2 id="delivery-title">Task completion</h2>
          <p>{total.toLocaleString()} tasks across your workspace</p>
        </div>
      </div>
      <div className="task-progress-body">
        <div
          className="completion-gauge"
          role="img"
          aria-label={`${completed} of ${total} tasks completed, ${percent}%`}
        >
          <svg viewBox="0 0 140 140" aria-hidden="true">
            <circle className="gauge-track" cx="70" cy="70" r="58" />
            <circle
              className="gauge-fill"
              cx="70"
              cy="70"
              r="58"
              pathLength="100"
              strokeDasharray={`${percent} 100`}
              transform="rotate(-90 70 70)"
            />
          </svg>
          <div className="gauge-label">
            <strong>
              {percent}
              <small>%</small>
            </strong>
            <span>{total ? "completed" : "No tasks yet"}</span>
          </div>
        </div>
        <dl className="completion-legend">
          {segments.map(([label, count, color]) => (
            <div key={label}>
              <dt>
                <i className={`legend-${color}`} />
                {label}
              </dt>
              <dd>{count.toLocaleString()}</dd>
            </div>
          ))}
        </dl>
      </div>
      <Link to="/tasks" className="panel-footer-link">
        Manage tasks <ArrowRight size={16} />
      </Link>
    </section>
  );
}
